import cn from "classnames";
import PlayArrowIcon from "@mui/icons-material/PlayArrow";

import { ImgBgResponsive } from "@/src/component/base/ImgBgResponsive";
import { ProviderHooks } from "@/src/hook";
import { StrapiComponentType } from "@/src/type";
import { LoadFromCDN } from "@/src/util";

import styles from "./VirtualTour.module.scss";

interface VirtualTourProps {
  virtualTours?: StrapiComponentType.Object.VirtualTour[];
  virtualTourTitle?: string;
  virtualTourType?: "matterport";
  mobileHint?: boolean;
  deviceWidthHint?: number;
  quality?: number;
  lazy?: "lazy" | "eager";
}

function VirtualTour({ virtualTours, virtualTourTitle, mobileHint, deviceWidthHint, quality, lazy }: VirtualTourProps) {
  const cms = ProviderHooks.useCMS();
  if (!virtualTours || virtualTours.length === 0) {
    return <></>;
  }

  const tourLink = virtualTours?.[0]?.slug;
  const imageUrl = virtualTours?.[0]?.preview?.data?.attributes?.url;
  const imageSize = mobileHint ? 600 : (deviceWidthHint ?? 800);
  if (!imageUrl || !tourLink) {
    return <></>;
  }

  /**
   * what the virtual tour in a Inline Frame
   */
  const handleWatchTour = () => {
    if (tourLink) {
      window.open(cms.constructLink(tourLink), "_self");
    }
  };

  return (
    <>
      <div className={cn(styles.container)}>
        <ImgBgResponsive
          imageUrl={LoadFromCDN.imageQualityAndSizeOptional(imageUrl, quality, imageSize)}
          className={styles.previewImage}
          lazy={lazy ?? (mobileHint ? "lazy" : "eager")}
          triggers={["scroll", "resize", "touchStart"]}
        />
        <div
          className={styles.tourOverlay}
          onClick={handleWatchTour}
        >
          <div className={styles.tourContent}>
            <div className={styles.playButton}>
              <PlayArrowIcon className={styles.playIcon} />
            </div>
            <div className={styles.tourText}>{virtualTourTitle ?? "Virtual Tour"}</div>
          </div>
        </div>
      </div>
      <div className={styles.spacing} />
    </>
  );
}

export default VirtualTour;
